import { authenticatedFetch } from "@beholos/holoscommon";
import { API_BASE_URL } from "./constants";

export const updatePassword = async (
  oldPassword: string,
  newPassword: string,
) => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/users/update-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ oldPassword, newPassword }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating the users password:', error);
    throw new Error('Error updating the users password');
  }
};

export const updateProfileInformation = async ({
  firstname,
  lastname,
  nationalIdentityNumber,
  phoneNumber,
  countryCode,
  birthDate,
  gender,
  address
}: {
  firstname: string;
  lastname: string;
  nationalIdentityNumber: number;
  phoneNumber: string;
  countryCode?: string;
  birthDate?: string;
  gender?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    countryCode?: string;
  };
}): Promise<string> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/users/update-profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstname,
        lastname,
        nationalIdentityNumber,
        phoneNumber,
        countryCode,
        birthDate,
        gender,
        address
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data.message || 'Profile updated successfully';
  } catch (error: any) {
    console.error('Error updating the users profile information:', error);
    throw new Error(`HTTP error! status: ${error.message}`);
  }
};